import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "col-md-9 mx-auto" }

import ProvidersList from "@/guiide/components/common/ProvidersList.vue";
import HeaderBanner from "../HeaderBanner.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'FlexibleIncomeHL',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(HeaderBanner, { title: "Flexible income" }),
    _createElementVNode("div", _hoisted_1, [
      _cache[0] || (_cache[0] = _createElementVNode("p", null, " Flexible income, which is also referred to as Drawdown, lets you flexibly take income from your pension, usually allowing you to withdraw up to 25% tax free, while keeping the rest invested. ", -1)),
      _cache[1] || (_cache[1] = _createElementVNode("p", null, " You can move your pension into drawdown in one go or move a bit in at a time. Up to 25% can normally be paid to you as tax-free cash, upfront, while the rest stays invested. You decide how much income to take (which is taxable), and when to take it. ", -1)),
      _cache[2] || (_cache[2] = _createElementVNode("ul", null, [
        _createElementVNode("li", null, " If you move your entire pension into drawdown, you'll receive all your tax-free cash in one lump sum payment. "),
        _createElementVNode("li", null, " If you choose to move your pension into drawdown in stages, then you'll receive your tax-free cash in stages too (up to 25% of the portion you move each time). ")
      ], -1)),
      _cache[3] || (_cache[3] = _createElementVNode("h4", { class: "mt-4" }, " Choosing your drawdown provider ", -1)),
      _cache[4] || (_cache[4] = _createElementVNode("p", null, [
        _createTextVNode(" A selection of three large providers which offer drawdown and a choice of investments are shown below. Many others are also available and you can find more information at "),
        _createElementVNode("a", {
          href: "https://www.moneyhelper.org.uk",
          target: "_blank"
        }, "moneyhelper.org.uk"),
        _createTextVNode(". ")
      ], -1)),
      _createVNode(ProvidersList, {
        "show-charges": false,
        title: "Providers"
      })
    ])
  ], 64))
}
}

})